import React from "react";
import qs from "qs";

interface PaginationFooterProps {
  onPageChange: (pageConfig: any) => void;
  metadata?: any;
  transparent?: boolean;
}

export const PaginationFooter = ({
  onPageChange,
  metadata,
}: PaginationFooterProps) => {
  const currentlyDisplayedMin =
    metadata?.pageNumber > 1
      ? (metadata?.pageNumber - 1) * metadata?.pageSize + 1
      : 1;
  const currentlyDisplayedMax =
    metadata?.pageNumber * metadata?.pageSize <= metadata?.totalEntries
      ? metadata?.pageNumber * metadata?.pageSize
      : metadata?.totalEntries;
  const previousPage = metadata?.pageNumber > 1 ? metadata?.pageNumber - 1 : 1;
  const nextPage =
    metadata?.totalPages > metadata?.pageNumber
      ? metadata?.pageNumber + 1
      : metadata?.pageNumber;

  return (
    <div className="flex items-center justify-between py-3 px-2">
      <div className="text-primary-700 dark:text-primary-300 font-sans text-sm">
        {currentlyDisplayedMin} - {currentlyDisplayedMax} /{" "}
        {metadata?.totalEntries}
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={() => {
            onPageChange(previousPage);
          }}
          disabled={metadata?.pageNumber <= 1}
          className="group flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg transition-colors hover:bg-primary-50 dark:hover:bg-primary-900/30 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <div className="icon-[ph--caret-left-bold] text-primary-500/70 dark:text-primary-400/70 h-5 w-5 transition-colors group-hover:text-primary-600 dark:group-hover:text-primary-300 group-disabled:text-primary-400/50 dark:group-disabled:text-primary-500/50" />
        </button>
        <button
          onClick={() => {
            onPageChange(nextPage);
          }}
          disabled={metadata?.pageNumber >= metadata?.totalPages}
          className="group flex h-8 w-8 cursor-pointer items-center justify-center rounded-lg transition-colors hover:bg-primary-50 dark:hover:bg-primary-900/30 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <div className="icon-[ph--caret-right-bold] text-primary-500/70 dark:text-primary-400/70 h-5 w-5 transition-colors group-hover:text-primary-600 dark:group-hover:text-primary-300 group-disabled:text-primary-400/50 dark:group-disabled:text-primary-500/50" />
        </button>
      </div>
    </div>
  );
};

export default PaginationFooter;
